import React from "react";
import classNames from "classnames";
import "./PageTitleButton.scss";
import SimpleButton from "../SimpleButton";

const PageTitleButton = props => {
    return (
        <SimpleButton
            id={props.id}
            type={!!props.type ? props.type : "default"}
            onClick={!!props.isActive ? props.onClick : null}
            text={props.label}
            icon={props.icon}
            disabled={!props.isActive}
        ></SimpleButton>
    );
};

export default PageTitleButton;
